/* 
 * TOGGLR
 * a plugin for toggling things
 * ============================
 *
 * When the user clicks an element, Togglr will update the text on the
 * element and toggle an "active" class. If the element is a label for
 * a radio button or checkbox, Togglr will also toggle the value of
 * that radio button or checkbox.
 * 
 * Other plugins can hook into the togglr-activate and togglr-deactivate
 * events.
 *
 */

; define('core/ef_plugins/togglr',["jquery"], function (jQuery) {
    (function ($, window, document, undefined) {
        "use strict";
        var pluginName = 'togglr',
            defaults = {
                activeText: 'less',
                inactiveText: 'more',
                toggleText: true, // Toggle between the active text and inactive when the trigger is clicked?              
                activeClass: 'is-active' // Class applied to the element when togglr is active.
            };

        // ReSharper disable once InconsistentNaming
        function Togglr(element, options) {
            this.element = element;
            this.$element = $(element);

            // We're not following the usual data-plugin-options attribute here because in some of our views,
            // it's not possible to generate JSON in the required format.
            this.metadata = {
                activeText: this.$element.data('togglr-active-text'),
                inactiveText: this.$element.data('togglr-inactive-text'),
            };
            this.options = $.extend({}, defaults, options, this.metadata);
            this._defaults = defaults;
            this._name = pluginName;
            this.init();
        }

        Togglr.prototype = {
            init: function () {
                var plugin = this;
                plugin.$radios = $(); // If plugin.options.input is a radio button, store all the radio buttons with the same name attribute.
                plugin.$input = $();
                plugin._active = false; // Set inactive state as default. External JS should check isActive(), not _active.

                if (plugin.element.tagName === 'LABEL') {
                    /* If the element is a label, the open/close state is stored in the
                    ** associated input's "checked" attribute. */
                    plugin.$input = $('#' + plugin.$element.attr('for'));
                    if (plugin.$input.length === 0) {
                        throw new Error("Togglr: The label must have a 'for' attribute and an associated input.");
                    }
                    if (plugin.$input.attr('type') === 'checkbox') {
                        plugin.$input.on('change.togglr', function () {
                            plugin._update();
                        });
                    } else if (plugin.$input.attr('type') === 'radio') {
                        plugin.$radios = $('input[name=' + plugin.$input.attr('name') + ']');
                        if (!plugin.options.$input.attr('name')) {
                            throw new Error("Togglr: Radio inputs must have 'name' attributes.");
                        }
                        plugin.$radios.on('change.togglr', function () {
                            plugin._update();
                        });
                    } else {
                        throw new Error("Togglr: Only checkbox and radio inputs are supported.");
                    }

                } else {
                    // If the trigger is not a label, the open/close state is stored in a variable.
                    plugin.$element.on('click.togglr', function (event) {
                        event.preventDefault();
                        plugin.toggle();
                    });
                }

                // Also update on init in case the trigger text in the HTML isn't right.
                plugin._update(true);
                return true; // Init was successful!
            },

            isActive: function () {
                var plugin = this,
                    active;
                if (plugin.$input.length === 1) {
                    active = plugin.$input.is(':checked');
                } else {
                    active = plugin._active;
                }
                return active;
            },

            toggle: function() {
                var plugin = this;
                if (plugin.$input.length === 1) {
                    plugin.options.prop('checked', !plugin.isActive());
                } else {
                    plugin._active = !plugin._active;
                }
                plugin._update();
            },

            _update: function () {
                var plugin = this,
                    newText = '';

                if (plugin.isActive()) {
                    plugin.$element.addClass(plugin.options.activeClass);
                    newText = plugin.options.activeText;
                    plugin.$element.trigger('togglr-activate');
                } else {
                    plugin.$element.removeClass(plugin.options.activeClass);
                    newText = plugin.options.inactiveText;
                    plugin.$element.trigger('togglr-deactivate');
                }
                
                if (plugin.options.toggleText) {
                   plugin.$element.text(newText);
                }
            },

            destroy: function () {
                var plugin = this,
                    activeClass = plugin.options.activeClass;
                // Remove the data
                plugin.$element.removeData('plugin_' + pluginName);
                // Unbind listeners
                plugin.$input.off('change.togglr');
                plugin.$radios.off('change.togglr');
                plugin.$element.off('click.togglr');
                plugin.$element.removeClass(activeClass);
            }

        };

        // Turn this into a jquery plugin & prevent multiple instantiations
        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName,
                        new Togglr(this, options));
                }
            });
        };

    })(jQuery, window, document);
});
